angular.module('aq.ui')
.filter('qaFilterSpecialCharacters', function() {
    return function(item) {
        var s= item.replace(/[^0-9a-zA-Z]+/g,'');
        return s.toLowerCase();
    };
});